<template>
  <div class="can-pedalsure hp-block-container">
    <h2 class="hp-block-title">What does road bike insurance cover?</h2>
    <div class="element-container hp-cards">
      <div>
        <b>Theft</b>: You’ll be fully covered if your road bike gets stolen,
        whether at home or out and about.
      </div>
      <div>
        <b>Damage</b>: We’ll pay for the repair costs if you’ve accidentally
        damaged your road bike or accessories or they’ve been vandalised.
      </div>
      <div>
        <b>Personal injury</b>: Injured yourself after a crash out on the road?
        It happens but don’t worry you're covered.
      </div>
      <div>
        <b>Public liability</b>: If someone else gets injured or their property
        damaged and they think you’re to blame, we’ll take care of it if they
        make a claim against you.
      </div>
      <div>
        <b>Overseas travel</b>:Peace-of-mind for your cycling holidays and
        international cycling events; including transit.
      </div>
      <div>
        <b>Loss of earnings</b>: If you’re injured after an incident on the bike
        and can’t work, we’ll provide a weekly payment.
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.can-pedalsure {
  // border-top: 1px solid $ps-border;
  border-bottom: 1px solid $ps-border;
}

.title {
  text-align: center;
  font-family: $family-regular;
  margin: 20px 0 0 0;
  font-size: 1.6rem;
  @include tablet {
    margin: 50px 0;
    font-size: 2.5rem;
  }
}
.subtitle {
  color: $ps-gray;
  line-height: 2rem;
}
</style>
